import React from 'react';
import Select from "react-select";

const CentralWastageInput = ({
    editableClass,
    readonlyClass,
    selectedDate,
    setSelectedDate,
    costCenter,
    selectStyles,
    selectedOutlet,
    itemOptions,
    selectedItem,
    setSelectedItem,
    mainQuantity,
    setMainQuantity,
    subQuantity,
    setSubQuantity,
    showSubUnitInput,
    editingItemId,
    handleAddItem,
    handleCancelEdit
}) => {
    return (
        <>
            <div className="flex gap-12 mb-2">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Date
                    </label>
                    <input
                        type="date"
                        className={editableClass}
                        value={selectedDate}
                        onChange={(e) => setSelectedDate(e.target.value)}
                        max={new Date().toLocaleDateString('en-CA')}
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Cost Center
                    </label>

                    <div className="text-sm w-[300px]">
                        <input
                            type="text"
                            className={readonlyClass}
                            value={costCenter}
                            readOnly
                        />
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-3 items-end gap-4 mb-6">
                <div className="col-span-1">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Item
                    </label>

                    <Select
                        options={itemOptions}
                        value={
                            selectedItem
                                ? {
                                    value: selectedItem.id,
                                    label: selectedItem.name,
                                    data: selectedItem
                                }
                                : null
                        }
                        onChange={(selectedOption) => {
                            setSelectedItem(selectedOption?.data || null);
                            setMainQuantity("");
                            setSubQuantity("");
                        }}
                        isSearchable
                        placeholder="Search or select item..."
                        className="react-select-container"
                        classNamePrefix="react-select"
                        styles={selectStyles}
                    />
                </div>

                <div className="grid grid-cols-2 gap-4 col-span-2">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Primary Unit
                        </label>

                        <div className="flex gap-3">
                            <div>
                                <label className="block text-sm text-gray-700 font-medium mb-1">
                                    UOM
                                </label>

                                <input
                                    type="text"
                                    className={readonlyClass}
                                    value={selectedItem?.uom || ""}
                                    readOnly
                                />
                            </div>

                            <div>
                                <label className="block text-sm text-gray-700 font-medium mb-1">
                                    Quantity
                                </label>

                                <input
                                    type="number"
                                    className={editableClass}
                                    value={mainQuantity}
                                    onChange={(e) => {
                                        const value = e.target.value;

                                        if (
                                            value === "" ||
                                            /^[0-9]*\.?[0-9]*$/.test(value)
                                        ) {
                                            setMainQuantity(value);
                                        }
                                    }}
                                    min="0"
                                    step="any"
                                    placeholder="Enter quantity"
                                />
                            </div>
                        </div>
                    </div>

                    {showSubUnitInput && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Secondary Unit
                            </label>

                            <div className="flex gap-3">
                                <div>
                                    <label className="block text-sm text-gray-700 font-medium mb-1">
                                        UOM
                                    </label>

                                    <input
                                        type="text"
                                        className={readonlyClass}
                                        value={selectedItem?.secondaryUom || ""}
                                        readOnly
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm text-gray-700 font-medium mb-1">
                                        Quantity
                                    </label>

                                    <input
                                        type="number"
                                        className={editableClass}
                                        value={subQuantity}
                                        onChange={(e) => {
                                            const value = e.target.value;

                                            if (
                                                value === "" ||
                                                /^[0-9]*\.?[0-9]*$/.test(value)
                                            ) {
                                                setSubQuantity(value);
                                            }
                                        }}
                                        min="0"
                                        step="any"
                                        placeholder="Enter quantity"
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <div className="flex gap-4 text-sm">
                <button
                    className={`py-1.5 px-3 rounded-md ${editingItemId
                        ? 'bg-yellow-600 hover:bg-yellow-700'
                        : 'bg-blue-600 hover:bg-blue-700'
                        } text-white`}
                    onClick={handleAddItem}
                >
                    {editingItemId ? "Update Item" : "Add Item"}
                </button>

                {editingItemId && (
                    <button
                        className="bg-gray-600 text-white py-1.5 px-3 rounded-md hover:bg-gray-700"
                        onClick={handleCancelEdit}
                    >
                        Cancel
                    </button>
                )}
            </div>
        </>
    );
};

export default CentralWastageInput;